import type { Negatives } from "models-webgl2";

export const isNullable = (v: any): v is Negatives => v == null;
